"use client";
import { useState, type ReactElement } from "react";

const CommonVideoButton = ({
  text = "Button",
  url = "/",
  version = "",
  isRounded,
  hasIcon,
  watchIcon,
  customIcon,
  target,
  textWeightMedium,
  customClass,
}: {
  text: string;
  url: string;
  version?: string;
  isRounded?: boolean;
  hasIcon?: boolean;
  watchIcon?: boolean;
  textWeightMedium?: boolean;
  customIcon?: ReactElement;
  target?: string;
  customClass?: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        className={`block w-fit py-[10px] text-[14px] duration-300 ease-in-out ${
          version == "gray"
            ? "bg-btnGray px-4 text-white xl:px-6"
            : "bg-transparent px-4 text-outlineText xl:px-6"
        } ${version == "white" ? "bg-[#202020] text-white" : ""} border-[0.8px] border-solid border-outlineBorder ${
          isRounded ? "rounded-[50px]" : "rounded-[4px]"
        } ${
          hasIcon || watchIcon || customIcon
            ? "flex items-center gap-2 px-4 pr-3"
            : "lg:px-8 xl:px-12"
        } ${textWeightMedium ? "font-medium" : "font-semibold"} ${customClass}`}
      >
        <span>{text}</span>

        {customIcon && <span> {customIcon} </span>}

        {watchIcon && (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M6 12.4997V9.82968C6 6.51968 8.35 5.15968 11.22 6.81968L13.53 8.15968L15.84 9.49968C18.71 11.1597 18.71 13.8697 15.84 15.5297L13.53 16.8697L11.22 18.2097C8.35 19.8397 6 18.4897 6 15.1697V12.4997Z"
                stroke="#202020"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
        {hasIcon && (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M8 21L16 12L8 3"
                stroke="#F8F8FF"
                strokeWidth="1.331"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
      </button>

      {isModalOpen && (
        <>
          <div
            onClick={handleCloseModal}
            className="fixed bottom-0 left-0 right-0 top-0 z-[99999] bg-black opacity-50"
          ></div>
          <div
            id="static-modal"
            aria-hidden="true"
            className="fixed left-1/2 top-1/2 z-[9999999] flex w-full -translate-x-1/2 -translate-y-1/2 transform items-center justify-center lg:w-[55%]"
          >
            <div className="relative w-full max-w-5xl p-4">
              <div className="relative rounded-lg bg-white shadow">
                <button
                  onClick={handleCloseModal}
                  aria-label="Close video modal"
                  className="absolute right-2 top-2 rounded-full bg-black p-2 text-white hover:bg-gray-800"
                >
                  ✕
                </button>
                <iframe
                  width="100%"
                  height="500"
                  src={url}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CommonVideoButton;
